/**
 * PlanetCenterOutpost — small floating button in the top-right corner of the
 * globe container. Always visible when the player owns an outpost on the
 * planet; clicking it smoothly rotates the globe to centre on that outpost.
 */

import { useCallback } from 'react';
import { usePlanetPanelStore } from './state/planetPanelStore';

export function PlanetCenterOutpost() {
  const selfPlayerId = usePlanetPanelStore((s) => s.selfPlayerId);
  const structures = usePlanetPanelStore((s) => s.structures);
  const requestCenter = usePlanetPanelStore((s) => s.requestCenter);

  const myOutpost = structures.find(
    (s) => s.owner_player_id === selfPlayerId && s.structure_type === 'outpost'
  );

  const handleClick = useCallback(() => {
    if (!myOutpost) return;
    requestCenter(myOutpost.lat, myOutpost.lon);
  }, [myOutpost, requestCenter]);

  if (!myOutpost) return null;

  return (
    <button style={btnStyle} onClick={handleClick}>
      ⌖ Center Outpost
    </button>
  );
}

const btnStyle: React.CSSProperties = {
  position: 'absolute',
  top: 14,
  right: 14,
  padding: '6px 14px',
  background: 'rgba(15, 27, 38, 0.85)',
  border: '1px solid rgba(32, 165, 166, 0.35)',
  borderRadius: 6,
  color: '#20a5a6',
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: 11,
  cursor: 'pointer',
  zIndex: 10,
  pointerEvents: 'auto',
};
